import { UserDashboardLayout } from '../../components/layout/UserDashboardLayout';
import { VideoManagementCard } from '../../components/dashboard/VideoManagementCard';

export function VideosPage() {
  return (
    <UserDashboardLayout>
      <div className="p-4 sm:p-6 max-w-full overflow-hidden">
        {/* Header */}
        <div className="mb-4 sm:mb-6">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">Video Introductions</h1>
          <p className="text-sm sm:text-base text-gray-600">
            Upload or link your video introductions to showcase your personality and skills to potential employers.
          </p>
        </div>

        {/* Video Management */}
        <VideoManagementCard />
      </div>
    </UserDashboardLayout>
  );
}
